import React from 'react'
import {
  Container,
  Title,
  Wrapper,
  GreenFrame,
  ProfilePhoto,
  Box,
  Info,
  H4,
  Information,
  HouseLogo,
} from './styles'

export default function QuemSomos() {

  return (
    <Container id="quemsomos">
      <Title>Quem Somos</Title>
      <Wrapper>
        <GreenFrame />
        <Box>
          <ProfilePhoto>
            <img
              style={{
                margin: "0px 0px 0px 0px",
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
              alt="Foto da Milena"
              src="https://res.cloudinary.com/ourplaceeglishschool/image/upload/c_fill,w_200,h_250,ar_9:16,g_auto/v1748533046/website/Quem%20Somos/Milena_p0ibwy.jpg"
            />
          </ProfilePhoto>
          <Info>
            <H4>Fundadora e idealizadora da Our Place - Escola de Idiomas</H4>
            <Information>
              Milena é a fundadora e idealizadora da Our Place - Escola de Idiomas, escola de inglês, espanhol, italiano, francês e português com foco em aulas personalizadas e em uma experiência de aprendizagem cuidadosa e envolvente. Formada em Psicologia, Educação Infantil e Pedagogia, construiu sua trajetória unindo desenvolvimento infantil e ensino de idiomas.
              <br/>
              <br/>
              O contato com o inglês começou ainda na infância e se aprofundou ao longo de anos de estudo, aulas particulares e vivência internacional, incluindo um período morando na Inglaterra, além de referências do inglês utilizado nos Estados Unidos. Essa formação sustenta uma abordagem contextualizada e próxima do uso real da língua.
              <br/>
              <br/>
              Com mais de 14 anos de experiência na área educacional, Milena atua hoje como responsável pedagógica da Our Place / Nuestro Lugar, acompanhando o desenvolvimento dos alunos e dando suporte contínuo à equipe de professores.
            </Information>
            <HouseLogo />
          </Info>
        </Box>
      </Wrapper>
    </Container>
  );
}
